<template>
    <div>
        <el-dialog
            :title="`帮扶计划${isView ? '查看' : '提交'}`"
            :visible.sync="dialogVisible"
            width="800px"
            :before-close="handleClose">
            <div>
                <div class="label-title">
                    业务类型：{{ detailInfo.businessTypeText }} &nbsp;&nbsp;&nbsp;&nbsp;供应商名称：{{
                        detailInfo.supplierNameCn
                    }}&nbsp;&nbsp;&nbsp;&nbsp;帮扶月份：{{ detailInfo.month }} &nbsp;&nbsp;&nbsp;&nbsp;月度绩效得分：
                    <span :class="+detailInfo.countScore < 90 ? 'red-score' : 'green-score'">
                        {{ detailInfo.countScore }}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;月度绩效目标得分：≥90
                </div>
                <indicatorTable ref="indicatorTable" />
                <div class="label-title">
                    <span v-if="!isView" class="require">*</span>
                    帮扶计划
                </div>
                <el-input
                    :disabled="isView"
                    maxlength="500"
                    show-word-limit
                    placeholder="请输入帮扶计划"
                    :rows="3"
                    v-model="helpValue"
                    type="textarea"></el-input>
                    <fileOperateView v-if="isView"  title="帮扶计划文件" :isView="isView" :fileList="fileList" @del="delFile" @upload-success="uploadSuccess" />
                    <fileOperate v-else title="帮扶计划文件" :isView="isView" :fileList="fileList" @del="delFile" />
            
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!isView" type="primary" :loading="submitLoading" @click="submit">提交</el-button>
                <el-button @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import fileOperate from '../../components/fileOperate.vue'
import fileOperateView from '../../components/fileOperateView.vue'
import indicatorTable from '../../components/indicatorTable.vue'
import {
    addSupplierLegalPersonPerformanceFile,
    getSupplierLegalPersonPerformanceFile,
    selectSupplierPerformanceConfigurationAdjustDetail,
} from '../../../../api/performManage.js'
import { BUSINESS_TYPE, YES_OR_NO, PERFORM_STATUS, ACTION_TYPE } from '../../constant.js'
export default {
    name: 'helpProject',
    components: { fileOperate, indicatorTable,fileOperateView },
    props: {},
    data() {
        return {
            fileList: [],
            detailInfo: {
                detailList: [],
            },
            helpValue: '',
            dialogVisible: false,
            isView: false,
            id: '',
            submitLoading: false,
            delList: [],
        }
    },
    methods: {
        init(id, isView) {
            this.id = id
            this.isView = isView
            this.dialogVisible = true
            getSupplierLegalPersonPerformanceFile({
                operativeFunction: ACTION_TYPE.SUBMIT_PLAN,
                performanceId: this.id,
            }).then(res => {
                if (res && +res.code === 0) {
                    //编辑时需要清空理由和附件，所以需要把原本的附件通过delList删除
                    if (isView) {
                        this.fileList = res.data.fileList
                        this.helpValue = res.data.operativeFunctionReason || ''
                    }else{
                        this.delList = res.data.fileList.map(v => v.id)
                    }
                }
            })
            selectSupplierPerformanceConfigurationAdjustDetail({
                id: this.id,
                operativeFunction: ACTION_TYPE.SUBMIT_PLAN,
            }).then(res => {
                if (res && +res.code === 0) {
                    res.data.businessTypeText = BUSINESS_TYPE.TRANSPORT === res.data.businessType ? '运输' : (BUSINESS_TYPE.DELIVERY === res.data.businessType ? '配送' : '配送(新)')
                    this.detailInfo = res.data
                    this.$refs['indicatorTable'].init(res.data.detailList)
                }
            })
        },
        delFile(fileId) {
            this.delList.push(fileId)
        },
        submit() {
            if (!this.isView) {
                if (!this.helpValue.trim()) {
                    return this.$message.warning('请填写帮扶计划')
                }
                if (!this.fileList.length) {
                    return this.$message.warning('请上传帮扶计划文件')
                }
                if (this.fileList.length > 10) {
                    return this.$message.warning('帮扶计划文件不可超过10个')
                }
                this.submitLoading = true
                addSupplierLegalPersonPerformanceFile({
                    fileList: this.fileList.map(v => {
                        return {
                            fileName: v.fileName,
                            fileUrl: v.fileUrl,
                            id: v.id || -1, //如果是新增的附件ID就传-1，否则就用回数据默认的ID
                        }
                    }),
                    operativeFunction: ACTION_TYPE.SUBMIT_PLAN,
                    operativeFunctionReason: this.helpValue,
                    performanceId: this.id,
                    deleteFileList: this.delList,
                })
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$emit('refresh')
                            this.$message.success('提交成功')
                            this.handleClose()
                        }
                    })
                    .finally(() => {
                        this.submitLoading = false
                    })
            }
        },
        uploadSuccess(fileList){
                this.fileList=fileList;
                if (!this.helpValue.trim()) {
                    return this.$message.warning('请填写帮扶计划')
                }
                if (!this.fileList.length) {
                    return this.$message.warning('请上传帮扶计划文件')
                }
                if (this.fileList.length > 10) {
                    return this.$message.warning('帮扶计划文件不可超过10个')
                }
                this.submitLoading = true
                addSupplierLegalPersonPerformanceFile({
                    fileList: this.fileList.map(v => {
                        return {
                            fileName: v.fileName,
                            fileUrl: v.fileUrl,
                            id: v.id || -1, //如果是新增的附件ID就传-1，否则就用回数据默认的ID
                        }
                    }),
                    // operativeFunction: ACTION_TYPE.SUBMIT_PLAN,
                    operativeFunction: '20',//帮扶计划补充材料
                    operativeFunctionReason: this.helpValue,
                    performanceId: this.id,
                    deleteFileList: this.delList,
                    supplementMaterialFlag: '1',//1:补充材料
                })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$emit('refresh')
                        this.$message.success('提交成功')
                        this.handleClose()
                    }
                })
                .finally(() => {
                    this.submitLoading = false
                })
            
        },
        handleClose() {
            this.$refs['indicatorTable'].reset()
            this.fileList = []
            this.delList = []
            this.helpValue = ''
            this.dialogVisible = false
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.el-textarea.is-disabled .el-textarea__inner{
    color: #666666;
}
.label-title {
    margin: 10px 0;
    .require {
        color: red;
    }
}
</style>
